import { defineMessages } from 'react-intl';

export default defineMessages({
    groupProgramEligibilityTitle: {
        id: 'ml.quoteandbind.views.payment-details.Group Program Eligibility',
        defaultMessage: 'Group Program Eligibility',
    },
    paymentMethodTitle: {
        id: 'ml.quoteandbind.views.payment-details.Payment Method',
        defaultMessage: 'Payment Method'
    },
    paymentFrequencyTitle: {
        id: 'ml.quoteandbind.views.payment-details.Payment Frequency',
        defaultMessage: 'Payment Frequency'
    },
    recurringPaymentDetailsTitle: {
        id: 'ml.quoteandbind.views.payment-details.Recurring Payment Details',
        defaultMessage: 'Recurring Payment Details'
    },
    downPaymentTitle: {
        id: 'ml.quoteandbind.views.payment-details.Down Payment',
        defaultMessage: 'Down Payment'
    },
    groupDiscountDescription: {
        id: 'ml.quoteandbind.views.payment-details.You may choose to provide the following information to determine your eligibility for our group program. For the best results, enter complete name or as many characters as possible.',
        defaultMessage: 'You may choose to provide the following information to determine your eligibility for our group program. For the best results, enter complete name or as many characters as possible.'
    },
    groupDiscountEligibilityQuestion: {
        id: 'ml.quoteandbind.views.payment-details.Would you like to determine eligibility for our group program?',
        defaultMessage: 'Would you like to determine eligibility for our group program?'
    },
    PaymentPlanFaqSection: {
        id: 'ml.quoteandbind.views.payment-details.PaymentPlanFaqSection',
        defaultMessage: 'The Monthly option means your payment will occur each month on the same calendar date. The Twice a Month option means you select the first deduction date and the second deduction date will occur 15 calendar days later. Please note that if you select your first deduction to begin in the last half of the month, the second deduction will occur in the first half of the following month. Read more": "The Monthly option means your payment will occur each month on the same calendar date.  The Twice a Month option means you select the first deduction date and the second deduction date will occur 15 calendar days later.  Please note that if you select your first deduction to begin in the last half of the month, the second deduction will occur in the first half of the following month. Read more'
    },
    Continue: {
        id: 'ml.quoteandbind.views.payment-details.Continue',
        defaultMessage: 'Continue'
    },
    Next: {
        id: 'ml.quoteandbind.views.payment-details.Next',
        defaultMessage: 'Next'
    },
    Edit: {
        id: 'ml.quoteandbind.views.payment-details.Edit',
        defaultMessage: 'Edit'
    },
    EditAccount: {
        id: 'ml.quoteandbind.views.payment-details.Edit Account',
        defaultMessage: 'Edit account'
    },
    MakePayment: {
        id: 'ml.quoteandbind.views.payment-details.Make Payment',
        defaultMessage: 'Make Payment'
    },
    AuthorizationAndSignatures: {
        id: 'ml.quoteandbind.views.payment-details.authorization and signatures',
        defaultMessage: 'proceed to authorization and signatures'
    },
    ProceedAuthorizationSignature: {
        id: 'ml.quoteandbind.views.payment-details.We\'ll proceed to authorization and signatures next',
        defaultMessage: 'We\'ll {AuthorizationSignature} next'
    },
    YourPayment: {
        id: 'ml.quoteandbind.views.payment-details.Your Payment',
        defaultMessage: 'your payment'
    },
    ProcessYourPayment: {
        id: 'ml.quoteandbind.views.payment-details.We\'ll process your payment next',
        defaultMessage: 'We\'ll process {YourPayment} next'
    },
    PaymentScheduleSubHeader: {
        id: 'ml.quoteandbind.views.payment-details.x on x',
        defaultMessage: '{paymentPlan} on {paymentSchedule}'
    },
    PaymentDetailsSubHeader: {
        id: 'ml.quoteandbind.views.payment-details.x - ending in x',
        defaultMessage: '{nickname} - ending in {last4Digits}'
    },
    Mortgage: {
        id: 'ml.quoteandbind.views.payment-details.Mortgage',
        defaultMessage: 'Mortgage'
    },
    AnnualPayment: {
        id: 'ml.quoteandbind.views.payment-details.Annual payment',
        defaultMessage: 'Annual payment'
    },
    MonthlyPayment: {
        id: 'ml.quoteandbind.views.payment-details.Monthly payment',
        defaultMessage: 'Monthly payment'
    },
    TwicePerMonth: {
        id: 'ml.quoteandbind.views.payment-details.Twice per month',
        defaultMessage: 'Twice per month'
    },
    TwoPay: {
        id: 'ml.quoteandbind.views.payment-details.Two pay',
        defaultMessage: 'Two pay'
    },
    FourPay: {
        id: 'ml.quoteandbind.views.payment-details.Four pay',
        defaultMessage: 'Four pay'
    },
    PayrollDeduct: {
        id: 'ml.quoteandbind.views.payment-details.Payroll deduct',
        defaultMessage: 'Payroll deduct'
    },
    AddAccount: {
        id: 'ml.quoteandbind.views.payment-details.Add account',
        defaultMessage: 'Add account'
    },
    PrintApplication: {
        id: 'ml.quoteandbind.views.payment-details.VIEWPRINT APPLICATION',
        defaultMessage: 'VIEW/PRINT APPLICATION'
    },
    ApplicationUnavailable: {
        id: 'ml.quoteandbind.views.payment-details.Application Download Unavailable',
        defaultMessage: 'Application Download Unavailable'
    },
    changingPaymentMethodAffectPremium: {
        id: 'ml.quoteandbind.views.payment-details.Changing payment method may affect premium.',
        defaultMessage: 'Changing payment method may affect premium.'
    },
    changingGroupEligibilityAffectPremium: {
        id: 'ml.quoteandbind.views.payment-details.Changing payment method or updating group eligibility information may change premium',
        defaultMessage: 'Changing payment method or updating group eligibility information may change premium'
    }, 
    ssnValidation: {
        id: 'ml.quoteandbind.views.payment-details.ssnValidation',
        defaultMessage: 'Please provide the last 4 digits of your SSN.'
    },
    misMatchMessageQB: {
        id: 'ml.quoteandbind.views.payment-details.payment misMatch',
        defaultMessage: 'Payment method Information must match with your selected down payment method'
    },
    preferredPaymentChangedAffectPremium: {
        id: 'ml.quoteandbind.views.payment-details.Changing preferred payment may affect total price.',
        defaultMessage: 'Changing preferred payment may affect total price.'
    },
});
